import { Component, inject, Injectable } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { BaseDialogService, NonNullableConfigData, TilbyDialogContentComponent, TilbyDialogToolbarComponent } from '@tilby/tilby-ui-lib/components/tilby-dialog';
import { lastValueFrom } from 'rxjs';


type ErrorViewerData = {
  title: string;
  message: string;
}

@Component({
  selector: 'app-error-viewer-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    TilbyDialogContentComponent,
    TilbyDialogToolbarComponent
  ],
  templateUrl: './error-viewer-dialog.component.html',
  styleUrl: './error-viewer-dialog.component.scss'
})
export class ErrorViewerDialogComponent {
  protected readonly data: ErrorViewerData = inject(MAT_DIALOG_DATA);
  
  title: string = this.data.title;
  message: string = this.data.message || 'Messaggio non presente';
}

@Injectable({
    providedIn: "root",
})
export class ErrorViewerDialogService extends BaseDialogService {
  private readonly dialogRef = inject(MatDialog);

  public openDialog(config?: NonNullableConfigData<ErrorViewerData>) {
    const data: ErrorViewerData = config?.data || { title: '', message: ''};
    
    const configEdited: NonNullableConfigData<ErrorViewerData> = {
      ...config,
      ...this.switchMobileDesktopDimensions({width: '600px'}),
      disableClose: true,
      data
    };

    return lastValueFrom(this.dialogRef.open(ErrorViewerDialogComponent, configEdited).afterClosed());
  }
}
